
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { NotificationModel } from './Communication.Api.Models.Notification';
import { CommunicationLogEditModel } from './Communication.Api.Models.CommunicationLogEdit';
import { LogEntryType } from 'enums/LogEntryType';
import { Model, ModelProperty } from 'models/Model';


export class CommunicationLogEntryModel extends Model<CommunicationLogEntryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'communicationLogEntry.property.id', isHidden: true },
		{ name: 'comment', type: 'string', languageString: 'communicationLogEntry.property.comment' },
		{ name: 'userId', type: 'guid', languageString: 'communicationLogEntry.property.userId' },
		{ name: 'taskActionId', type: 'guid', languageString: 'communicationLogEntry.property.taskActionId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'communicationLogEntry.property.taskflowId' },
		{ name: 'timestamp', type: 'Date', languageString: 'communicationLogEntry.property.timestamp' },
		{ name: 'modified', type: 'Date', languageString: 'communicationLogEntry.property.modified' },
		{ name: 'additionalData', type: 'string', languageString: 'communicationLogEntry.property.additionalData' },
		{ name: 'companyId', type: 'guid', languageString: 'communicationLogEntry.property.companyId' },
		{ name: 'notifications', type: 'NotificationModel[]', languageString: 'communicationLogEntry.property.notifications', isHidden: true, isArray: true, isObject: true, new: () => { return new NotificationModel }, properties: () => { return NotificationModel.classProperties } },
		{ name: 'edits', type: 'CommunicationLogEditModel[]', languageString: 'communicationLogEntry.property.edits', isHidden: true, isArray: true, isObject: true, new: () => { return new CommunicationLogEditModel }, properties: () => { return CommunicationLogEditModel.classProperties } },
		{ name: 'statusType', type: 'string', languageString: 'communicationLogEntry.property.statusType' },
		{ name: 'type', type: 'LogEntryType', languageString: 'communicationLogEntry.property.type' },
		{ name: 'uniqueId', type: 'string', languageString: 'communicationLogEntry.property.uniqueId' }
	];
	[key: string]: any;
	
	public id?: string;
	public comment: string;
	public userId?: string;
	public taskActionId?: string;
	public taskflowId?: string;
	public timestamp?: Date;
	public modified?: Date;
	public additionalData: string;
	public companyId?: string;
	public notifications: NotificationModel[];
	public edits: CommunicationLogEditModel[];
	public statusType: string;
	public type: LogEntryType;
	public uniqueId: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.comment = '';
		this.userId = undefined;
		this.taskActionId = undefined;
		this.taskflowId = undefined;
		this.timestamp = undefined;
		this.modified = undefined;
		this.additionalData = '';
		this.companyId = undefined;
		this.notifications = [];
		this.edits = [];
		this.statusType = '';
		this.type = 0;
		this.uniqueId = '';
		
	}
	getProperties(){
		return CommunicationLogEntryModel.classProperties;
	}
}

